import React, { Component, PropTypes } from 'react';

const styles = {
  container: {
    display: 'flex',
    flex: '1 0 auto'
  },
  tab: {
    boxSizing: 'border-box',
    flexGrow: 1,
    textAlign: 'center',
    height: 48,
    lineHeight: '48px',
    borderStyle: 'solid solid solid none',
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  last: {
    borderStyle: 'solid none solid none'
  },
  active: {}
};

class StoreTabs extends Component {
  static propTypes = {
    tabs: PropTypes.array,
    activeTab: PropTypes.string,
    onChange: PropTypes.func,
    themeColor: PropTypes.string
  };

  getTabStyle(active, last) {
    const { themeColor } = this.props;
    return Object.assign(
      {},
      {
        color: active ? themeColor : null
      },
      styles.tab,
      active && styles.active,
      last && styles.last
    );
  }

  handleTab(tab) {
    const { onChange, activeTab } = this.props;
    if (tab.name !== activeTab) {
      onChange && onChange(tab.name);
    }
  }

  render() {
    const { activeTab, tabs } = this.props;
    const count = tabs.length;
    return (
      <div style={styles.container}>
        {tabs.map((tab, index) => (
          <div
            key={tab.name}
            onTouchTap={this.handleTab.bind(this, tab)}
            style={this.getTabStyle(
              tab.name === activeTab,
              index === count - 1
            )}
          >
            {tab.label}
          </div>
        ))}
      </div>
    );
  }
}

export default StoreTabs;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreTabs.js